export default __webpack_public_path__ + "static/media/5.239ded15.jpg";